export const _fr = {
    stage: {
        label: "Stage"
    },
    group: {
        label: "Groupe"
    },
    refMaterialResourceId: {
        label: "Ressource matérielle"
    },
    humanResourcesId: {
        label: "Ressource(s) humaine(s)"
    },
    commentary: {
        label: "Commentaire"
    },
    refPlaneId: {
        label: "Type avion"
    },
    refOrganizationId: {
        label: "Compagnie"
    }
};

export const _en = {
    stage: {
        label: "Course"
    },
    group: {
        label: "Group"
    },
    refMaterialResourceId: {
        label: "Material resource"
    },
    humanResourcesId: {
        label: "Human resources"
    },
    commentary: {
        label: "Comment"
    },
    refPlaneId: {
        label: "Plane type"
    },
    refOrganizationId: {
        label: "Organization"
    }
};